import { render } from "./PlaceList.vue?vue&type=template&id=b9157210&scoped=true"
import script from "./PlaceList.vue?vue&type=script&lang=js"
export * from "./PlaceList.vue?vue&type=script&lang=js"

import "./PlaceList.vue?vue&type=style&index=0&id=b9157210&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9157210"]])

export default __exports__